GoalSettingsCtrl = ($scope, $location, $filter, flash, GoalSettingsService, LocationTrackingService, $analytics) ->
  $analytics.eventTrack('TGT_loaded')
  $scope.isLoading = true
  $scope.goalSettings = {}
  $scope.isSubmitting = false

  GoalSettingsService.get().then (data) ->
    $scope.goalSettings = data
  .finally ->
    $scope.isLoading = false

  $scope.save = ->
    $scope.isSubmitting = true
    GoalSettingsService.save($scope.goalSettings.goal).then (resp) ->
      flash.success $filter('translate')('API_SUCCESS')
      $location.path(LocationTrackingService.previousLocation())
    .catch (resp) ->
      flash.error $filter('translate')('API_ERROR')
    .finally ->
      $scope.isSubmitting = false


GoalSettingsCtrl.$inject = [
  '$scope'
  '$location'
  '$filter'
  'flash'
  'GoalSettingsService'
  'LocationTrackingService'
  '$analytics'
]

module.exports = GoalSettingsCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/goal-settings/goal-settings-controller.coffee